module.exports = __webpack_public_path__ + "img/btn-menu-close.d9be6cb0.svg";